import { Flex, Modal, ModalBody, ModalCloseButton, ModalContent, ModalOverlay, useBoolean } from '@chakra-ui/react';
import { AUTO_BRAND_DISCARD } from 'constants/mixpanel';
import { Mixpanel } from 'libs/third-party/Mixpanel/mixpanel';

import { autoBrandModal } from './AutoBrand.config';
import { AutoBrandForm } from './AutoBrandForm';
import DiscardModal from './DiscardModal';

interface AutoBrandProps {
  isOpen: boolean;
  onClose?: () => void;

  // Triggered after brand data has been updated by auto brand
  handleTabsChange?: () => void;
}

export const AutoBrand = ({ isOpen = false, onClose = () => {}, handleTabsChange = () => {} }: AutoBrandProps) => {
  const [isDiscardOpen, toggleDiscard] = useBoolean(false);
  const [hasBrand, toggleAutoBrand] = useBoolean(false);

  /**
   * Confirm discard closes both modal
   */
  const confirmDiscard = () => {
    Mixpanel.track(AUTO_BRAND_DISCARD.eventName);
    toggleAutoBrand.off();
    toggleDiscard.off();
    onClose();
  };

  const onCloseModal = () => {
    if (hasBrand) {
      toggleDiscard.on();
      return;
    }

    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={onCloseModal} isCentered closeOnOverlayClick={false} returnFocusOnClose={false}>
      <div id={autoBrandModal}>
        <DiscardModal isOpen={isDiscardOpen} onClose={toggleDiscard.off} onConfirm={confirmDiscard} />
        <ModalOverlay zIndex={'var(--vg-zIndices-popOver)'} />
        <ModalContent
          minW={'47.5rem'}
          minH='32rem'
          containerProps={{
            zIndex: 'var(--vg-zIndices-popOver)',
          }}
        >
          <ModalBody padding={'unset'} borderRadius={6}>
            <Flex minW={'22rem'} minH={'26.87rem'} flexDirection={'row'} gap={'1rem'}>
              <AutoBrandForm
                closeModal={onClose}
                toggleAutoBrand={toggleAutoBrand}
                hasBrand={hasBrand}
                handleTabsChange={handleTabsChange}
              />
            </Flex>
          </ModalBody>

          <ModalCloseButton
            position={'absolute'}
            background={'white'}
            borderRadius={'9999px'}
            right={'-2.5rem'}
            top={'0'}
            _hover={{ bg: 'white-alpha.500' }}
            data-testid={'icon-auto-brand-close-button'}
          />
        </ModalContent>
      </div>
    </Modal>
  );
};
